import { useMemo } from 'react';

const LEFT_DOTS_ITEM_ID = -1;
const RIGHT_DOTS_ITEM_ID = -2;

export const usePagination = ({
  currentPage,
  totalCount,
  pageSize,
  displayPageCount = 4,
}) => {
  const data = useMemo(() => {
    var current = currentPage,
      last = Math.ceil(totalCount / pageSize),
      delta = displayPageCount / 2,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;

    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || (i > left && i <= right)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push(l === 1 ? LEFT_DOTS_ITEM_ID : RIGHT_DOTS_ITEM_ID);
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  }, [currentPage, totalCount, pageSize, displayPageCount]);

  return data;
};
